import debounce from 'lodash/debounce';

const HTMLCS = require('imports-loader?additionalCode=var%20define%20=%20undefined;!@purple/html_codesniffer'); // eslint-disable-line
Object.assign(window, HTMLCS);

const ignoredCodes = [
  'WCAG2AA.Principle1.Guideline1_4.1_4_3.G18.Abs',
  'WCAG2AA.Principle1.Guideline1_4.1_4_3.G18.Fail',
  'WCAG2AA.Principle1.Guideline1_4.1_4_3.G18.BgImage',
  'WCAG2AA.Principle1.Guideline1_4.1_4_3.G145.Abs',
];

function scanDom(appDom) {
  HTMLCS.HTMLCS.process('WCAG2AA', appDom, () => {
    HTMLCS.HTMLCS.getMessages()
      .forEach((message) => {
        // ignore notices and color contrast warnings due to lots of false positives
        if (message.type !== 3 && !ignoredCodes.includes(message.code)) {
          console[message.type === 1 ? 'error' : 'warn'](message.element, message.msg, message.code); // eslint-disable-line no-console
        }
      });
  });
}

export default function initDomWatcher(appDom) {
  const observer = new MutationObserver(debounce(scanDom.bind(this, appDom), 250));
  observer.observe(appDom, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}
